import type { EetStatus, EetSubmission, Receipt } from './domain'

export const PaymentType = {
  Card: 'Card',
  Cash: 'Cash',
  Qr: 'Qr',
} as const
export type PaymentType = (typeof PaymentType)[keyof typeof PaymentType]

export const SaleType = {
  None: 'none',
  Absolute: 'absolute',
  Percent: 'percent',
} as const
export type SaleType = (typeof SaleType)[keyof typeof SaleType]

export const EetEnvironment = {
  Playground: 'playground',
  Test: 'test',
  Production: 'production',
} as const
export type EetEnvironment = (typeof EetEnvironment)[keyof typeof EetEnvironment]

export const EetSubmissionStatus = {
  Pending: 'pending',
  Confirmed: 'confirmed',
  Rejected: 'rejected',
  Offline: 'offline',
} as const
export type EetSubmissionStatus = (typeof EetSubmissionStatus)[keyof typeof EetSubmissionStatus]

/**
 * Account features, as in the backend `FeatureList`. A request to a disabled feature returns 403.
 */
export const Feature = {
  Bank: 'bank',
  Qr: 'qr',
  Todos: 'todos',
  AutoInvoicing: 'autoInvoicing',
  ContractMaterial: 'contractMaterial',
  EmailInvoice: 'emailInvoice',
  Orders: 'orders',
  CashRegister: 'cashRegistry',
  CountryField: 'countryField',
  Webhook: 'webhook',
  SumUp: 'sumUp',
  InvoicePaidConfirmation: 'invoicePaidConfirmation',
  Catalog: 'catalog',
  Warehouse: 'warehouse',
  Eshop: 'eshop',
} as const
export type Feature = (typeof Feature)[keyof typeof Feature]

// Compile-time checks: these enums must stay equal to the API spec, so a spec change fails the build here.
type Same<A, B> = [A] extends [B] ? ([B] extends [A] ? true : false) : false
type Check<T extends true> = T
export type EnumsMatchSpec = [
  Check<Same<PaymentType, Receipt['paymentType']>>,
  Check<Same<EetEnvironment, EetStatus['environment']>>,
  Check<Same<EetSubmissionStatus, EetSubmission['status']>>,
]
